import CancelDocumentRequestModal from './CancelDocumentRequestModal'

export default CancelDocumentRequestModal
